import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
        margin:0,
      }}
      copyright="2026 上海申浦 "
      links={[{
        key:'ssss',
        title:'网站备案号:沪ICP备2026023948号',
        href:'https://beian.miit.gov.cn',
        blankTarget:true,
      }]}
      
    />
  );
};

export default Footer;
